import { render } from "./Or_tableProfit.vue?vue&type=template&id=c0e897aa&scoped=true&ts=true"
import script from "./Or_tableProfit.vue?vue&type=script&lang=ts"
export * from "./Or_tableProfit.vue?vue&type=script&lang=ts"

import "./Or_tableProfit.vue?vue&type=style&index=0&id=c0e897aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e897aa"]])

export default __exports__